import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiTableContainer(theme: Theme): Components['MuiTableContainer'] {
  return {
    variants: [
      ...theme.shadows.map((shadow, index) => ({
        props: { 'data-elevation': index },
        style: { boxShadow: shadow },
      })),
    ],
    styleOverrides: {
      root: {
        overflow: 'hidden',
        boxShadow: theme.shadows[3],
        borderRadius: theme.shape.borderRadius,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  };
}
